import useCustomerModelChange from "@src/backbone/hooks/useCustomerModelChange";

export const useIsConnected = (): boolean => {
  const [, customer] = useCustomerModelChange(["id_customer"]);
  return !!customer.getId();
};
